import React, { useState } from 'react'
import { PhoneInput } from 'react-international-phone'
import { PhoneNumberUtil } from 'google-libphonenumber'
import { ajaxPost } from '../../../ajax'

export default function Signin({token, league, defaults, onSignup, onSuccess}) {
  const [phone, setPhone] = useState(defaults.phone || '')
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const phoneUtil = PhoneNumberUtil.getInstance()
  
  const isPhoneValid = () => {
    try {
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))
    } catch (error) {
      return false
    }
  }

  const verifyPhone = async () => {
    setLoading(true)
    const params = { token: token, phone: phone }
    const response = await ajaxPost(`/plugin/leagues/${league.id}/registrations/signin`, params)
    const json = await response.json()
    setLoading(false)
    if (json.error) setError(json.error)
    else onSuccess({id: json.id, phone: phone, new: false})
  }

  const checkKeyDown = (e) => {
    if (e.key === 'Enter' && isPhoneValid()) verifyPhone()
  }

  return <div className={'signin-form' + (loading ? ' isLoading' : '')} onKeyDown={checkKeyDown}>
    <div className='signin-title'>{`Continue as ${league.company_name} user`}</div>
    { error && <div className='registration-error'>{error}</div> }
    { loading && <div className='animated-spinner'></div> }
    <div>
      <PhoneInput
        defaultCountry='us'
        value={phone}
        error={true}
        onChange={(phone) => setPhone(phone)}
      />
      <div className='signin-desc'>You will receive an SMS verification that may apply message and data rates.</div>
    </div>
    <button className='signin-button' disabled={!isPhoneValid()} onClick={verifyPhone}>Continue</button>
    <div className='signup'>
      Don’t have Plei account?&nbsp;<span className='signup__link' onClick={onSignup}>Sign Up</span>
    </div>
  </div>
}
